<template>
    <div class="form__section">
        <div class="row">
            <div class="col-12">
                <div class="form-section__header">
                    <h2 class="title title--3">{{ formLabels.title }}</h2>
                    <p v-if="formLabels.description">{{ formLabels.description }}</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction1" id="benefitAction1" type="radio" />
                        <label for="benefitAction1">{{ formLabels.fields.benefitAction1 }}</label>
                    </div>
                    <!-- <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction2" id="benefitAction2" type="radio" />
                        <label for="benefitAction2">{{ formLabels.fields.benefitAction2 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction3" id="benefitAction3" type="radio" />
                        <label for="benefitAction3">{{ formLabels.fields.benefitAction3 }}</label>
                    </div> -->
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.action" :value="formLabels.fields.benefitAction4" id="benefitAction4" type="radio" />
                        <label for="benefitAction4">{{ formLabels.fields.benefitAction4 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.action.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="formData.benefit.action === formLabels.fields.benefitAction3">
            <div class="col-12">
                <h3>{{ formLabels.fields.amendmentDetails }}</h3>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.amendAction" value="Add partner" id="benefitTypeAddFamily" type="radio" />
                        <label for="benefitTypeAddFamily">I want to add my partner</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.benefit.amendAction" value="Remove partner" id="benefitTypeRemoveFamily" type="radio" />
                        <label for="benefitTypeRemoveFamily">I want to remove my partner</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.benefit.amendAction.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="(formData.benefit.action === formLabels.fields.benefitAction2) || formData.benefit.amendAction">
            <div class="col-12">
                <div class="form-section__header">
                    <p>Spouse/Partner details</p>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].firstName.$error}]">
                    <label for="forename1">{{ formLabels.personFields.firstName }}</label>
                    <input v-model="formData.familyMembers[0].firstName" id="forename1" type="text" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.firstName" v-tooltip="formTooltips.personFields.fields.firstName">?</span>
                    <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].firstName.$error">This field is required</span>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].lastName.$error}]">
                    <label for="lastName1">{{ formLabels.personFields.lastName }}</label>
                    <input v-model="formData.familyMembers[0].lastName" id="lastName1" type="text" />
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.lastName" v-tooltip="formTooltips.personFields.fields.lastName">?</span>
                    <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].lastName.$error">This field is required</span>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div :class="['form-field',{'form-field--error':$v.formData.familyMembers.$each[0].dob.$error}]">
                    <label for="dob1">{{ formLabels.personFields.dob }}</label>
                    <date-picker v-model="formData.familyMembers[0].dob" id="dob1" format="DD/MM/YYYY" value-type="format"></date-picker>
                    <span class="form-field__tooltip" v-if="formTooltips && formTooltips.personFields && formTooltips.personFields.fields.dob" v-tooltip="formTooltips.personFields.fields.dob">?</span>
                    <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].dob.$error">This field is required</span>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <div :class="['form-field form-field--dropdown', {'form-field--error':$v.formData.familyMembers.$each[0].gender.$error}]">
                    <label for="gender1">{{ formLabels.personFields.gender }}</label>
                    <select v-model="formData.familyMembers[0].gender">
                        <option :value="null || undefined" disabled>Please select</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                    </select>
                    <span v-if="formTooltips.sexToolTip" class="form-field__tooltip" v-tooltip="formTooltips.sexToolTip">?</span>
                    <span class="form-field__error" v-if="$v.formData.familyMembers.$each[0].gender.$error">This field is required</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="showAssessmentFields">
            <div class="col-12">
                <div class="form-section__header">
                    <p>Select your assessment(s)</p>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.myAssessments" :value="formLabels.fields.benefitType1" id="myAssessment1" type="checkbox" />
                        <label for="myAssessment1">{{ formLabels.fields.benefitType1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.myAssessments" :value="formLabels.fields.benefitType2" id="myAssessment2" type="checkbox" />
                        <label for="myAssessment2">{{ formLabels.fields.benefitType2 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.myAssessments" :value="formLabels.fields.benefitType3" id="myAssessment3" type="checkbox" />
                        <label for="myAssessment3">{{ formLabels.fields.benefitType3 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.myAssessments" :value="formLabels.fields.benefitType4" id="myAssessment4" type="checkbox" />
                        <label for="myAssessment4">{{ formLabels.fields.benefitType4 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.myAssessments.$error">Please select an option</span>
                </div>
            </div>
        </div>
        <div class="row row--margin-top" v-if="showPartnerAssessmentFields">
            <div class="col-12">
                <div class="form-section__header">
                    <p>Select your spouse/partner's assessment(s)</p>
                </div>
            </div>
            <div class="col-12">
                <div class="form-group form-group--checkbox-row">
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.partnerAssessments" :value="formLabels.fields.benefitType1" id="personalAssessment1" type="checkbox" />
                        <label for="personalAssessment1">{{ formLabels.fields.benefitType1 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.partnerAssessments" :value="formLabels.fields.benefitType2" id="personalAssessment2" type="checkbox" />
                        <label for="personalAssessment2">{{ formLabels.fields.benefitType2 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.partnerAssessments" :value="formLabels.fields.benefitType3" id="personalAssessment3" type="checkbox" />
                        <label for="personalAssessment3">{{ formLabels.fields.benefitType3 }}</label>
                    </div>
                    <div class="form-field form-field--checkbox">
                        <input v-model="formData.partnerAssessments" :value="formLabels.fields.benefitType4" id="personalAssessment4" type="checkbox" />
                        <label for="personalAssessment4">{{ formLabels.fields.benefitType4 }}</label>
                    </div>
                    <span class="form-group__error" v-if="$v.formData.partnerAssessments.$error">Please select an option</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import DatePicker from 'vue2-datepicker';

export default {
    props: {
        formLabels: {
            type: Object,
            required: true
        },
        formTooltips: {
            type: Object
        }
    },
    components: { DatePicker },
    inject: ['$v'],
    watch: {
        'formData.benefit.action': {
            handler: function(newVal) {

                // Unset family members
                this.formData.familyMembers = [{}];
                this.formSummary[1].fields = {
                    'Family members': [{}]
                }

                // Unset family members or set relationship if the correct action has been selected
                if(newVal === this.formLabels.fields.benefitAction2) {
                    this.formData.familyMembers[0].relationship = 'Spouse/Partner';
                    this.formSummary[1].fields = {
                        'Family members': [{ relationship: 'Spouse/Partner' }]
                    }
                }

                if(this.formData.benefit.amendAction && newVal !== this.formLabels.fields.benefitAction3) {
                    this.formData.benefit.amendAction = undefined;
                }

                // Reset other form values on action change
                if(this.formData.myAssessments) {
                    this.formData.myAssessments = [];
                }
                if(this.formData.partnerAssessments) {
                    this.formData.partnerAssessments = [];
                }
            }
        },
        'formData.benefit.amendAction': {
            handler: function(newVal) {

                // Unset family members
                this.formData.familyMembers = [{}];
                this.formSummary[1].fields = {
                    'Family members': [{}]
                }
                
                if(newVal) {
                    this.formData.familyMembers[0].relationship = 'Spouse/Partner';
                    this.formSummary[1].fields = {
                        'Family members': [{ relationship: 'Spouse/Partner' }]
                    }
                }

                if(this.formData.myAssessments) {
                    this.formData.myAssessments = [];
                }
                if(this.formData.partnerAssessments) {
                    this.formData.partnerAssessments = [];
                }
            }
        },
        'formData.benefit': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
        'formData.familyMembers': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
        'formData.myAssessments': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
        'formData.partnerAssessments': {
            handler: function(newVal) {
                this.buildSummary(newVal);
            },
            deep: true
        },
    },
    computed: {
        ...mapGetters(['formData','formSummary']),
        formConditionals: {
            get() {
                return this.$store.state.formConditionals;
            }, 
            set(value) {
                this.$store.commit('updateFormConditionals',value);
            }
        },
        showAssessmentFields() {
            return (this.formData.benefit.action === this.formLabels.fields.benefitAction1) || (this.formData.benefit.action === this.formLabels.fields.benefitAction2);
        },
        showPartnerAssessmentFields() {
            return this.formData.benefit.amendAction && this.formData.benefit.amendAction === 'Add partner' || this.formData.benefit.action === this.formLabels.fields.benefitAction2;
        },
        hasAssessments() {
            return this.formData.myAssessments.length || this.formData.partnerAssessments.length;
        },
        benefitFields() {
            return this.formSummary[1].fields;
        }
    },
    methods: {
        setConditionals() {
            // We need to store the full object paths for use in the core form
            this.formConditionals.familyFields = function() { return this.formData.benefit.amendAction || this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction2 };
            this.formConditionals.myAssessments = function() { return (this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction1) || (this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction2); };
            this.formConditionals.partnerAssessments = function() { return this.formData.benefit.amendAction && this.formData.benefit.amendAction === 'Add partner' || this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction2; };
            this.formConditionals.amendAction = function() { return this.formData.benefit.action && this.formData.benefit.action === this.formLabels.benefit.fields.benefitAction3 }
        },
        buildSummary(fieldData) {
            let prettyLabels = {
                    amendmentDetails: 'Amendment details',
                    action: 'Assessment action',
                    amendAction: 'Amend action'
                };

            this.formSummary[1].title = this.formLabels.title;

            for(let key of Object.keys(fieldData)) {
                let label = this.formLabels[key];

                if(label) {
                    this.benefitFields[label] = fieldData[key];
                } else if(prettyLabels[key]) {
                    this.benefitFields[prettyLabels[key]] = fieldData[key];
                }
            }

            // Build the family data summary if data is present
            if(Object.keys(this.formData.familyMembers[0])) {
                for(let [mKey,member] of this.formData.familyMembers.entries()) {
                    for(let mfKey of Object.keys(member)) {
                        let label = this.formLabels['personFields'][mfKey];

                        if(label) {
                            this.benefitFields['Family members'][mKey][label] = member[mfKey];
                        }
                    }
                }
            }

            // Set the assessment data
            if(this.formData.myAssessments.length) {
                this.benefitFields['My chosen assessments'] = this.formData.myAssessments;
            }
            if(this.formData.partnerAssessments.length) {
                this.benefitFields['My spouse/partner\'s chosen assessments'] = this.formData.partnerAssessments;
            }
        }
    },
    mounted() {
        this.setConditionals();

        this.formSummary.push({
            fields: {
                'Family members': [{}]
            }
        });
    }
}
</script>